module.exports = __webpack_public_path__ + "static/media/Bulk_Trucks_Availability_sample.85c8c807.csv";